import { AdminExamRoomRequestPhysicalInfoDetails } from '@exam-center/exam-location-management';
import { PaperSection } from '@shared/components';

export default function ExamLocationRequestRoomPhysicalInfoPage() {
  return (
    <PaperSection title='ข้อมูลทางกายภาพ'>
      <AdminExamRoomRequestPhysicalInfoDetails />
    </PaperSection>
  );
}
